// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewPasswordModal_wrapper__Wweig","form":"NewPasswordModal_form__aMiI9","fields":"NewPasswordModal_fields__WInIe","errorText":"NewPasswordModal_errorText__Y9bMC"};